"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTableHeaderCol = exports.SmartTableHeaderGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Table_1 = __importDefault(require("../../ui/Table"));
var mobx_react_1 = require("mobx-react");
var enums_1 = require("../../enums");
var _ = __importStar(require("lodash"));
var Icon_1 = require("../../ui/Icon");
var IconSymbols_1 = require("../../generated/IconSymbols");
var react_2 = require("react");
var SmartTableHeaderGroup = function (_a) {
    var headers = _a.headers, productTourPrefix = _a.productTourPrefix;
    var _b = (0, react_2.useState)(""), currentSortKey = _b[0], setCurrentSortKey = _b[1];
    var hasValue = function (value) {
        return value !== undefined && value !== null && value.length > 0;
    };
    productTourPrefix = hasValue(productTourPrefix)
        ? "--".concat(productTourPrefix)
        : "";
    return ((0, jsx_runtime_1.jsx)(Table_1.default.Header, __assign({ className: "smart-table__header-group " }, { children: headers.map(function (e, i) {
            var productTourSelector = hasValue(e.productTourText)
                ? "product-tour".concat(productTourPrefix, "--").concat(e.id.replace(".", "_"))
                : "";
            return ((0, react_1.createElement)(exports.SmartTableHeaderCol, __assign({}, e, { className: "".concat(e.cellClassName || "", " ").concat(e.id === "actions"
                    ? "smart-table-cell--action smart-table-cell--xxs"
                    : "", "\n            smart-table-cell--").concat(e.columnWidthSize ? e.columnWidthSize : enums_1.UiSizes.XXS), header: e, headers: headers, sortColKey: currentSortKey, onClick: function () {
                    setCurrentSortKey(e.id);
                    e.action && e.action(e, headers);
                }, key: i + "", tourId: productTourSelector })));
        }) })));
};
exports.SmartTableHeaderGroup = SmartTableHeaderGroup;
exports.SmartTableHeaderCol = (0, mobx_react_1.observer)(function (props) {
    var header = props.header, headers = props.headers, className = props.className, sortColKey = props.sortColKey, onClick = props.onClick;
    var _a = (0, react_2.useState)(false), isSortAsc = _a[0], setIsSortAsc = _a[1];
    return ((0, jsx_runtime_1.jsx)(Table_1.default.HeaderCol, __assign({ className: "".concat(className || "", " smart-table-cell--").concat(_.kebabCase(header.id)), "data-clickable": typeof header.action === "function", onClick: function () {
            setIsSortAsc(!isSortAsc);
            onClick(header.id, isSortAsc);
        } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "smart-table__header", "data-tourid": props.tourId }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "smart-table__header-content ".concat(header.showSortIcons && header.id === sortColKey ? "pr-3" : "") }, { children: header.content })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "smart-table__header-icon" }, { children: header.showSortIcons ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [header.id === sortColKey && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: enums_1.Enums.UiSizes.SM, symbol: isSortAsc ? IconSymbols_1.IconSymbols.ArrowDown : IconSymbols_1.IconSymbols.ArrowUp })), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: enums_1.Enums.UiSizes.SM, symbol: IconSymbols_1.IconSymbols.SortNone })] })) : null }))] })) })));
});
